export default "__VITE_ASSET__4fsoZCIf__"